import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';
import { LoadManager, StepInfoManager } from './custom-collection-utility.js';

export class CustomCollectionFlowComponent extends Component {
  connectedCallback() {
    try {
      super.connectedCallback();

      // Get data from the component element itself since data attributes are on the component
      this.collectionHandle = this.getAttribute('data-collection-handle') || 'maaltijden';
      this.stepsElements = this.querySelectorAll('.step-wrapper');
      this.stepsCount = parseInt(this.getAttribute('data-steps-count') || '1');
      this.stepInfo = this.#initializeStepInfo();

      document.addEventListener('flow-state-changed', this.#updateFlowVisualState);
      document.addEventListener('sync-quick-filters', this.#debouncedPostRender);

      this.stepsElements.forEach((step) => {
        step.addEventListener('click', this.#handleStepClick);
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  disconnectedCallback() {
    // Clean up event listener
    document.removeEventListener('flow-state-changed', this.#updateFlowVisualState);
    document.removeEventListener('sync-quick-filters', this.#debouncedPostRender);
    this.#debouncedPostRender?.cancel?.();

    this.stepsElements?.forEach((step) => {
      step.removeEventListener('click', this.#handleStepClick);
    });

    super.disconnectedCallback();
  }

  /**
   * Initializes step info from session storage or creates it if not present
   * @returns {Object} The step info object
   */
  #initializeStepInfo() {
    try {
      /** @type {any} */ 
      const initialStepInfo = StepInfoManager.defaultStepInfo(this.collectionHandle || '', this.stepsCount || 1);
  
      // Delay the update request to ensure other components are initialized
      // setTimeout(() => {
        // Dispatch the flow state changed event
        this.#updateFlowVisualState(StepInfoManager.createFlowStateChangedEvent(initialStepInfo), true);
      // }, 300);

      return initialStepInfo;
    } catch (error) {
      return {};
    }
  }

  updateFlowStepWithProductFiltering = () => {
    try {
      let stepInfo = StepInfoManager.getStepInfo() || null;
      stepInfo = StepInfoManager.updateStepInfo({ 'step-count': 1 });
      // Dispatch the flow state changed event
      this.#updateFlowVisualState(StepInfoManager.createFlowStateChangedEvent(stepInfo), true);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  // Debounced post-render handler using shared utility
  #debouncedPostRender = debounce(() => {
    try {
      const stepInfo = StepInfoManager.getStepInfo() || null;
      if (!stepInfo || !this.stepsElements?.length) return;
      const currentIndex = (/** @type {any} */ (stepInfo)['step-count'] || 1) - 1;
      const stepType = this.stepsElements[currentIndex]?.getAttribute('data-step-type') || '';
      
      // if (stepType) StepInfoManager.updateStepHeadings(stepType);
    } catch (error) {
      console.error(error);
    }
  }, 100);

  /** @param {CustomEvent} event */
  #updateFlowVisualState = (event, sendUpdateRequest = false) => {
    try {
      LoadManager.addLoader();
      this.stepInfo = StepInfoManager.getStepInfo() || null;
      
      if(this.stepsElements && this.stepInfo) {
        const stepInfoAny = /** @type {any} */ (this.stepInfo);
        this.stepsElements.forEach((step, index) => {
          if(this.stepInfo && index < (stepInfoAny['step-count'] || 1)) {
            step.classList.add('active');
            step.querySelector('.step-progress-bar')?.classList.add('active');
          }
          else {
            step.classList.remove('active');
            step.querySelector('.step-progress-bar')?.classList.remove('active');
          }
        });

        if(sendUpdateRequest) {
          StepInfoManager.dispatchFlowVisualUpdateRequested(this.stepInfo);
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
    finally {
      LoadManager.removeLoader();
    }
  }

  /** @param {Event} event */
  #handleStepClick = (event) => {
    try {
      const step = /** @type {HTMLElement} */ (event.currentTarget);
      if(step && step.classList.contains('active')) {
        const stepIndex = this.stepsElements ? Array.from(this.stepsElements).indexOf(/** @type {Element} */ (step)) : -1;
        
        if (this.stepInfo && stepIndex >= 0) {
          this.stepInfo = StepInfoManager.updateStepInfo({ 'step-count': stepIndex + 1 });
          // Dispatch the flow state changed event
          this.#updateFlowVisualState(StepInfoManager.createFlowStateChangedEvent(this.stepInfo), true);
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

if (!customElements.get('custom-collection-flow-component')) {
  customElements.define('custom-collection-flow-component', CustomCollectionFlowComponent);
}